
define("bundles/product", function(){});
